// The "Test print" dialog: offered when the setup is complete, and from the Set up menu. The page is a replay disk
// (replay.js) with a test page (testprint.js): the C64 prints it through its serial port to the device.
import { assetUrl } from '../core/assets.js';
import { buildReplayDisk } from './replay.js';
import { loadPicture, testPrintEvents } from './testprint.js';
import { button, openWizardDialog, paragraph } from './wizard_dialog.js';

// download(name, parts): the page's download helper. intro: the setup was just completed.
export function openTestPrint({ download, intro = false }) {
  const dlg = openWizardDialog({ onRequestClose: () => dlg.close() });
  const show = dlg.show;

  const make = async () => {
    show('Test print', [paragraph('Making the test page…')], []);
    try {
      const prgRes = await fetch(assetUrl('replay.prg'));
      if (!prgRes.ok) throw new Error(`replay.prg not found (${prgRes.status}): run make replay in web/`);
      const disk = buildReplayDisk(testPrintEvents(await loadPicture(assetUrl('samples/testprint.png'))), new Uint8Array(await prgRes.arrayBuffer()));
      download('printy-test-page_replay.d64', [disk]);
      show(
        'Test print',
        [
          paragraph('The disk image <strong>printy-test-page_replay.d64</strong> is downloaded. Now:'),
          steps(),
        ],
        [button('Close', () => dlg.close()), button('Download again', make, 'outline secondary')],
      );
    } catch (e) {
      show('Test print', [paragraph(`<strong>The test page could not be made:</strong> ${e.message}`)], [button('Close', () => dlg.close(), 'outline secondary'), button('Try again', make)]);
    }
  };

  const steps = () => {
    const ol = document.createElement('ol');
    ol.innerHTML = `
      <li>Attach the disk image to your C64 as <strong>drive 8</strong> (on an Ultimate: mount it from the menu, or use its web interface).</li>
      <li>Type <code>LOAD"REPLAY",8</code>, then <code>RUN</code>. The screen shows a counter while the page prints (about 10 seconds).</li>
      <li>The page appears here: a title, a picture and the line <em>Print Successfully</em>. If the device is in Wi-Fi printing mode, it goes to the print server instead: switch <em>Wi-Fi printing</em> off in the header to see it here.</li>`;
    return ol;
  };

  show(
    'Test print',
    [
      paragraph(intro ? '<strong>The setup is complete.</strong> ' + 'Print a test page to see that everything works?' : 'Print a test page to see that everything works?'),
      paragraph('It is a title, a picture and a line of text. The C64 prints it from a disk image that this page makes for you.'),
    ],
    [button(intro ? 'Not now' : 'Close', () => dlg.close(), 'outline secondary'), button('Make the test disk', make)],
  );
}
